import clsx from "clsx";
import { PropsWithChildren } from "react";
import { ExternalLinkProps, TextLinkType } from "../../types";
import { getLinkStyles } from "../../helpers";
import { ArrowUpRight } from "nvs-ds-icons/react/nvs";

export const EXTERNAL_LINK_ARIA_LABEL = "Arrow icon indicating external link";

export function ExternalLink({
  className,
  size,
  linkType = TextLinkType.primary,
  ...props
}: PropsWithChildren<ExternalLinkProps>) {
  return (
    <a
      className={clsx(
        className,
        "inline-flex items-center",
        getLinkStyles({ linkType, size }),
      )}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {props.children}
      <ArrowUpRight
        // Icon is scaled based on font-size
        className="inline-block h-[1.2em] w-auto"
        aria-label={EXTERNAL_LINK_ARIA_LABEL}
      />
    </a>
  );
}
